import { namespace, schema, backendDocType, docPrivilege } from './config'
import loader, {
  ShopRewardRestorer,
  generateReferenceDoc,
  queryManifest,
} from './loader'
import listview, { useTranspile } from './listview'
import { ticketProfile, useScopeName } from './ticket'
import { addViewManifest } from '../Config'

const manifest = {
  loader,
  schema,
  namespace,
  backendDocType,
  privilege: docPrivilege,
  queryManifest,
  useTranspile,
  generateReferenceDoc,
  restore: ShopRewardRestorer,
  listview,
  ticketProfile,
  useScopeName,
  order: 0,
}

addViewManifest(manifest)
